import types from 'app/config/files/products.json';
import { ProductsId, ProductTypes } from 'app/models/types';
import { StoreProductField } from 'app/models/types/store/product';

export const getProductTypes = (): StoreProductField['types'] => {
  const config = types.product_types as ProductTypes
  return (Object.keys(config) as ProductsId[]).map(key => {
    return { 
      id: key,
      selectedAmount: config[key].default_amount,
      maxAmount: config[key].max_amount,
      requiresId: config[key].requires_pax_identification,
      defaultAmount: config[key].default_amount,
    }
  }).reduce((acc, curr) => {
    const { id, ...rest} = curr
    acc[id] = { id, ...rest }
    return acc
  }, {} as StoreProductField['types'] )
};
